import { render, staticRenderFns } from "./mailManage.vue?vue&type=template&id=0f0d8238&scoped=true&"
import script from "./mailManage.vue?vue&type=script&lang=js&"
export * from "./mailManage.vue?vue&type=script&lang=js&"
import style0 from "./mailManage.vue?vue&type=style&index=0&id=0f0d8238&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0d8238",
  null
  
)

export default component.exports